import { motion } from "framer-motion";

const PageHero = ({ eyebrow, title, description, backgroundImage, children }) => (
  <section className="relative min-h-[70vh] flex items-center overflow-hidden">
    <div className="absolute inset-0">
      <img src={backgroundImage} alt="" className="w-full h-full object-cover" />
      <div className="hero-overlay absolute inset-0" />
    </div>
    <div className="relative z-10 container mx-auto px-4 py-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="max-w-3xl"
      >
        <motion.span
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className="inline-block font-display text-xs tracking-[0.4em] uppercase text-primary mb-4 px-4 py-1.5 rounded-full border border-primary/30 bg-primary/5"
        >
          {eyebrow}
        </motion.span>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">{title}</h1>
        <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">{description}</p>
        {children}
      </motion.div>
    </div>
    {/* Animated bottom line */}
    <div className="absolute bottom-0 left-0 right-0 h-px overflow-hidden">
      <div className="particle-line h-full animate-wave" />
    </div>
  </section>
);

export default PageHero;
